import { DSDealBar } from 'shared-definitions/types'
import { ApiResponseDealBarLink } from 'data-source/types.wp'
import { dealBarMapper } from 'data-source/mappers/dealBarMapper'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function codecGetDealBar(
  raw: ApiResponseDealBarLink,
  opts: PLinkMapperOpts
): DSDealBar | null {
  if ('code' in raw) {
    return null
  }
  const input = raw.data
  return dealBarMapper(input, opts)
}
